import React, {Component} from 'react';
// import SearchPageContent from '../SearchPageContent';
import Picture from './Picture';
import SearchBox from './SearchBox';


class Error404 extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                <section id="errorPage404" className="topMainVisual errorPage">
                    <div className="pictureFrame colCentered">
                        <div className="colLeft">
                            {/*<Picture src={this.props.errorJson.ErrorImage.Value} alt={this.props.errorJson.ErrorImageAlt.Value} />*/}
                            <img alt="Error 404" className="visual" src="/m/articles/Nioxin-404-error-banner_d.jpg" />
                        </div>
                        <div className="colRight">
                            <div className="verticalWrapper">
                                <div className="inner verticalAlign">
                                    <h1>404</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


            <section className="main fixWidth">
                <section className="searchContent searchContent--error">
                    <div className="searchInput searchWrap">
                        <p>
                            {this.props.errorJson.ErrorDescription.Value}
                        </p>
                        <SearchBox is404 countries={this.props.countries} placeholeder={this.props.errorJson.SearchText.Value} searchButtonText={this.props.errorJson.SearchButtonText.Value} />
                        <a href="/" id="" className=" button--back button">{this.props.errorJson.HomepageButtonText.Value}</a>
                    </div>
                </section>
            </section>
        </div>
        )
    }
}
export default Error404;
